module.exports = __webpack_public_path__ + "img/web_pic_feature1.e7794da7.png";